import {MultiSelect} from "../../../../../../../common/design2/multi-select/multi-select";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import {ErrorHighlighter} from "../../../../../../../../light/error-highlighter";
import {Static2} from "../../../../../../../../../react/static-2";
import {scrollIntoView} from "../../../../../../../../light/scroll-into-view";

export const AndType = ({fieldConfig, state, key, next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({eh, domRef}) => {
        // const invalid = !state.value[key]?.length;
        const invalid = false;
        return next({
            labelTop: 6,
            invalid,
            highlightErrors: () => {
                eh.start();
                scrollIntoView(domRef.get());
            },
            controls: ({showErrors}) => (
                <div className="">
                    {MultiSelect({
                        style: {
                            color: showErrors && invalid && "danger",
                        },
                        domRef: domRef.set,
                        className: eh.css,
                        forcedExpandLeft: true,
                        list: Object.keys(fieldConfig.values),
                        itemToLabel: (v) => fieldConfig.values[v],
                        placeholder: "Select",
                        isSelected: (v) => state.value[key]?.includes(v),
                        onSelect: (v) => stateChangeNestedValue(state, [key], (_) => [..._ ?? [], v]),
                        onRemove: (v) => stateChangeNestedValue(state, [key], (_) => _.length === 1 ? (
                            undefined
                        ) : (
                            _.filter((v1) => v1 !== v)
                        )),
                        onClear: () => stateChangeNestedValue(state, [key], (_) => undefined),
                        xdQaNamePrefix: "Demographics Search "+fieldConfig.labelForUser,
                    })}
                </div>
            ),
        });
    },
);
